import {Component, ElementRef, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {AnonymousService} from '../../../../services/anonymous-service';
import {AuthService} from '../../../../services/auth-service/auth-service.service';
import {UserService} from '../../../../services/users-service/user-service';
import {Router} from '@angular/router';
import {MdSnackBar, MdSnackBarConfig} from '@angular/material';
import {FormBuilder, FormGroup, FormGroupDirective, Validators} from '@angular/forms';
import {ErrorService} from '../../../../util/error_service/error.service';
import {FileComponent} from '../../../../a2-components/file/file.component';
import {ToastService} from '../../../../util/toast-service/toast.service';
import {Constants} from '../../../../util/Constants';
import '../../../../util/custom-alert/custom-alert.component';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {
  pageTitle = 'Create User';
  public userForm: FormGroup;
  public uUser: boolean;
  public cUser: boolean;
  public switchCreate: boolean;
  public isloading: boolean;
  public createText = 'Create Agent';
  public uplodText: String;
  public agentType: String;
  public allSuccessfulMsg: string;
  public partiallySuccessfulMsg : string;
  public unsucceessfulMsg : string;

  //variables for excel upload
  public successfulAgents: any;
  public unsuccessfulAgents: any;
  public failedRows: any;

  public onlineFlag = navigator.onLine;
  @ViewChild('excel') inputEl: ElementRef;
  // @ViewChild('agentProfilePicture') agentEl: ElementRef;

  @ViewChild(FormGroupDirective) myForm;

  mobnumPattern = '^((\\+91-?)|0)?[0-9]{7,14}$';

  public roleId: any;
  public successText: string;
  public errorText: String;
  public numberExists: any;
  public emailExists: any;
  public userEmail: any;

  constructor(public _sharedService: SharedService, public anonymousService: AnonymousService,
              public authService: AuthService, public agentService: UserService,
              public router: Router, public snackBar: MdSnackBar, public fb: FormBuilder, public errorHandler: ErrorService,
              public toast: ToastService) {
    this.switchCreate = true;
    this.cUser = true;
    this.agentType = 'super';
    this.uplodText = 'Upload Agents';
    this.isloading = false;
    this.createForm();
    // console.log('Online status' + this.onlineFlag);

    this.userEmail = JSON.parse(localStorage.getItem(Constants.PROFILE)).data[0].email ;

  }

  ngOnInit() {
  }

  createForm() {
    this.userForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobileNo: ['', [Validators.required, Validators.pattern(this.mobnumPattern)]],
      altMobileNo: ['', [Validators.pattern(this.mobnumPattern)]],
      address: ['', [Validators.required]],
    });
  }

  // check if phone number exists
  checkNum = () => {
    this._sharedService.checkIfNumberExist(this.userForm.value.mobileNo).subscribe(
      data => {
        this.numberExists = data;
        if (this.numberExists) {
          this.userForm.controls.mobileNo.setErrors({'numberExists': true});
        }
      }, err => {
        const error = this.errorHandler.errorHandlerWithText(this.checkNum, err);
        // console.log(error.message);
        this.numberExists = null;
      })
  }

  // check if email address exists
  checkEmail = () => {
  this._sharedService.checkUserExist(this.userForm.value.email,'').subscribe(
    data => {
      this.emailExists = data;

      if (this.emailExists) {
        this.userForm.controls.email.setErrors({'emailExists': true});
      }

    }, err => {
      const msg = this.errorHandler.errorHandlerWithText(this.checkEmail, err);
      // console.log(msg.message);
      this.emailExists = null;
    })
}

  resetForm() {
    this.myForm.resetForm();
  }

  // Swap between uploading user and creating users
  getVal() {
    if ( this.cUser === true ) {
      this.cUser = false;
      this.uUser = true;
    } else {
      this.cUser = true;
      this.uUser = false;
    }
  }



  onSubmit() {
    this.userForm.disable();
    this.createUser();
  }

  onSubmitFIle() {
    this.isloading = true;
    this.uplodText = 'Creating Agents...';
    this.createMultipleUser();
  }


  createUser = () => {
    this.isloading = true;
    this.createText = 'Creating user...';

    if (this.userForm.value) {
      // console.log(this.userForm.value);
     this.createAgent(); ;
    }
  }


// create agent
  createAgent = () => {
    // const inputEl: HTMLInputElement = this.agentEl.nativeElement;
    const formData = new FormData();

      this.authService.createAgent(this.userForm.value, formData).subscribe(
        data => {
          // console.log(data);
          this.isloading = false;
          this.resetForm();
          this.userForm.enable();
          this.createText = 'Create user';
          this.successText = 'Agent created successfully';
          this.toast.showSuccess('Agent created successfully', 'Success');
        },
        err => {
          // console.log(err);
          const errorText = this.errorHandler.errorHandlerWithText(this.createAgent, err);
          this.isloading = false;
          this.createText = 'Create user';
          this.toast.showError(errorText.errorText, 'Error');
          this.userForm.enable();
        }
      )
    // }
  }


  // upload user excel file
  createMultipleUser = () => {

    const inputEl: HTMLInputElement = this.inputEl.nativeElement;
    const fileCount: number = inputEl.files.length;
    const formData = new FormData();
    if (fileCount > 0) {
      // console.log('started');

      formData.append('agentSheetFile', inputEl.files.item(0));
      this.roleId = 1;
      this.authService.createMultipleUser( this.roleId, formData).subscribe(
        response => {
          // console.log("success");
          const result = response.data[0];
          this.successfulAgents = result.successful;
          this.unsuccessfulAgents = result.unsuccessful;

          this.allSuccessfulMsg = this.successfulAgents + 'Agent(s) were created successfully ';

          this.partiallySuccessfulMsg = `
             ${this.successfulAgents} of ${this.successfulAgents+this.unsuccessfulAgents}
             Agent(s) was created successfully. An email containing the report has been sent to ${this.userEmail}
            `;

          this.unsucceessfulMsg = `No Agent was created. An email containing the report has been sent to ${this.userEmail}`;

          this.isloading = false;
          this.uplodText = 'Create Agent';
        },
        error => {
          // console.log("failed");
          // console.log(error);
          const msg = this.errorHandler.errorHandlerWithText(this.createMultipleUser, error);
          // console.log(msg);
        }
      );
    } else {
      // console.log('Empty file upload')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/User management/create-user/create-user.component.ts